export const CREATE_ORDER_API_DETAIL = {
  notEnoughCoins: 'Not enough coins',
  wrongAmount: 'You cant specify negative or zero amount!',
  noActiveBillingPeriod: 'No active billing period',
  emptyCart: "The cart is empty or there're no available products",
  fieldRequired: 'Field required',
} as const

export const CREATE_ORDER_API_DETAIL_FRAGMENT = {
  skuId: 'sku_id',
  notFound: 'not found',
  notEnoughStockQuantity: 'not enough stock quantity',
  product: 'Product',
} as const

export const CREATE_ORDER_VALIDATION_LOC = {
  phone: 'phone',
  email: 'email',
  postalCode: 'postal_code',
  quantity: 'quantity',
} as const

export const CREATE_ORDER_ADDRESS_FIELDS = ['country', 'city', 'address'] as const
